import { alpha, Badge, Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Colors } from 'src/shared/components/styles/colors';
import { useGlobals } from 'src/shared/contexts/appContext';
import { MeRoutesEnum } from 'src/shared/models/enums/routes.enum';

type DashboardMeNavigateButtonProps = {
  title: string;
  text: string;
  icon: React.ReactNode;
  link: string;
};

export const DashboardMeNavigateButton = (props: DashboardMeNavigateButtonProps) => {
  const { title, text, icon, link } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { currentMember } = useGlobals();

  return (
    <Button
      onClick={() => navigate(link)}
      variant='contained'
      sx={{
        px: 4,
        py: 3,
        backgroundColor: Colors.White,
        color: Colors.HeaderTextColor,
        height: '100%',
        width: '100%',
        justifyContent: 'flex-start',
        '&:hover': {
          backgroundColor: (theme) => alpha(theme.palette.background.paper, 0.8),
        },
      }}
    >
      <Box display='flex' flexDirection='column' justifyContent='start' height='100%' width='100%' alignItems='center'>
        <Box alignItems='center' sx={{ height: 60 }}>
          {link === MeRoutesEnum.MemberMyPage ? (
            <Badge
              badgeContent={(currentMember?.currentInvoices && currentMember.currentInvoices.length) ?? 0}
              sx={{ '.MuiBadge-badge': { marginLeft: '10px', marginTop: '10px' } }}
              color='error'
              // anchorOrigin={{
              //   vertical: 'top',
              //   horizontal: 'left',
              // }}
            >
              {icon}
            </Badge>
          ) : (
            icon
          )}
        </Box>
        <Typography variant='h6' fontWeight='700' textTransform='none'>
          {t(title)}
        </Typography>
        <Typography variant='body1' textAlign='center' textTransform='none'>
          {t(text)}
        </Typography>
      </Box>
    </Button>
  );
};
